export default (props = {}) => <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<g id="vuesax/linear/send-2">
<g id="send-2">
<path id="Vector" d="M6.66641 5.2668L13.7414 2.90846C16.9164 1.85013 18.6414 3.58346 17.5914 6.75846L15.2331 13.8335C13.6497 18.5918 11.0497 18.5918 9.46641 13.8335L8.76641 11.7335L6.66641 11.0335C1.90807 9.45013 1.90807 6.85846 6.66641 5.2668Z" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
<path id="Vector_2" d="M8.92578 11.3745L11.9091 8.38281" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</g>
</svg>
